module.exports = __webpack_public_path__ + "img/1 手机.de9ec119.png";